import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Promo, PromoBrand } from '../../types'
import ActionTypes from './actionTypes'

type FetchPromoBrandRequest = {
    type: typeof ActionTypes.PROMO_BRAND_FETCH_REQUEST;
    payload: never;
}

type FetchPromoBrandFailure = {
    type: typeof ActionTypes.PROMO_BRAND_FETCH_FAILURE;
    payload: Error;
}

type FetchPromoBrandSuccess = {
    type: typeof ActionTypes.PROMO_BRAND_FETCH_SUCCESS;
    payload: PromoBrand[];
}

/**
 * Fetch promo brands
 */
function fetchBrands() {
    return createAction<RootState, Promo[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/brands`,
        method: 'GET',
        types: [
            ActionTypes.PROMO_BRAND_FETCH_REQUEST,
            ActionTypes.PROMO_BRAND_FETCH_SUCCESS,
            ActionTypes.PROMO_BRAND_FETCH_FAILURE,
        ],
    })
}

export type FetchPromoBrandAction = FetchPromoBrandRequest
    | FetchPromoBrandFailure
    | FetchPromoBrandSuccess

export default fetchBrands
